import React from "react"
import Layout from "../../components/layout"
import LayoutNieuwsbrief from "../../components/layoutnieuwsbrief"
import Image1 from "../../images/nieuwsbriefjul2019/foto1.jpg"
import Image2 from "../../images/nieuwsbriefjul2019/foto2.jpg"
import Image3 from "../../images/nieuwsbriefjul2019/foto3.jpg"
import Image4 from "../../images/nieuwsbriefjul2019/foto4.jpg"
import Image5 from "../../images/nieuwsbriefjul2019/foto5.jpg"
import Image6 from "../../images/nieuwsbriefjul2019/foto6.jpg"
import Image7 from "../../images/nieuwsbriefjul2019/foto7.jpg"
import Image8 from "../../images/nieuwsbriefjul2019/foto8.jpg"
import Image9 from "../../images/nieuwsbriefjul2019/foto9.jpg"
import Image10 from "../../images/nieuwsbriefjul2019/foto10.jpg"
import Image11 from "../../images/nieuwsbriefjul2019/foto11.jpg"
import Image12 from "../../images/nieuwsbriefjul2019/foto12.jpg"
import Image13 from "../../images/nieuwsbriefjul2019/foto13.jpg"
import Image14 from "../../images/nieuwsbriefjul2019/foto14.jpg"
import Image15 from "../../images/nieuwsbriefjul2019/foto15.jpg"
import Image16 from "../../images/nieuwsbriefjul2019/foto16.jpg"
import Image17 from "../../images/nieuwsbriefjul2019/foto17.jpg"
import Image18 from "../../images/nieuwsbriefjul2019/foto18.jpg"
import Image19 from "../../images/nieuwsbriefjul2019/foto19.jpg"
import Image20 from "../../images/nieuwsbriefjul2019/foto20.jpg"
import Image21 from "../../images/nieuwsbriefjul2019/foto21.jpg"
import Image22 from "../../images/nieuwsbriefjul2019/foto22.jpg"
import Image23 from "../../images/nieuwsbriefjul2019/foto23.jpg"
import Image24 from "../../images/nieuwsbriefjul2019/foto24.jpg"
import Image25 from "../../images/nieuwsbriefjul2019/foto25.jpg"
import Image26 from "../../images/nieuwsbriefjul2019/foto26.jpg"
import Image27 from "../../images/nieuwsbriefjul2019/foto27.jpg"
import Image28 from "../../images/nieuwsbriefjul2019/foto28.jpg"
import Image29 from "../../images/nieuwsbriefjul2019/foto29.jpg"
import Image30 from "../../images/nieuwsbriefjul2019/foto30.jpg"
import Image31 from "../../images/nieuwsbriefjul2019/foto31.jpg"
import { Image, RowElement, LeftAlignedImage } from "../../components/imagecomponents"
import { Ondertekening } from "../../components/snippets.js"
import Seo from "../../components/seo"

const Nieuwsbrief = () => (
  <Layout>
    <Seo title="Nieuwsbrief juli 2019" />

    <LayoutNieuwsbrief>
      <h2>Nieuwsbrief juli 2019</h2>

      <h3>Examens</h3>
      <p>
        Het was wederom een succesvol jaar voor Dr. T.S. Wilkinson memorial High School en Junior College. alle
        examenkandidaten slaagden. Van harte gefeliciteerd allemaal.
      </p>
      <Image src={Image1} alt="" />
      <br />

      <h3>Geslaagd voor klas 12 Junior College</h3>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <RowElement src={Image2} alt="" tekst="Anil Yadav (12 comm Eng)" />
        <RowElement src={Image3} alt="" tekst="Charulata Madankar (12 comm Eng)" />
        <RowElement src={Image4} alt="" tekst="Shubanghi Choudhar (12 comm Hin)" />
        <RowElement src={Image5} alt="" tekst="Saloni Dhurve (12 comm Hin)" />
      </div>

      <br />
      <h3>Geslaagd voor klas 10 High School</h3>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <RowElement src={Image6} alt="" tekst="Nitin Rabde (10 Hin)" imgMaxWidth="220px" />
        <RowElement src={Image7} alt="" tekst="Swati Khobragade, (10 Eng)" imgMaxWidth="220px" />
        <RowElement src={Image8} alt="" tekst="Ashish Kumar (10 Eng)" imgMaxWidth="220px" />
        <RowElement src={Image9} alt="" tekst="Deepak Martin (10 Eng)" imgMaxWidth="220px" />
        <RowElement src={Image10} alt="" tekst="Muskan Ansari (10 Hin)" imgMaxWidth="220px" />
        <RowElement src={Image11} alt="" tekst="Sagar Dongre (10 Hin)" imgMaxWidth="220px" />
        <RowElement src={Image12} alt="" tekst="Durgesh Kangle (10 Hin)" imgMaxWidth="220px" />
      </div>

      <p>
        Onlangs vroeg Aneeta Patel mij een stuk te schrijven voor de schoolkrant over mijn ervaringen met Nav-Jeevan.
        Omdat dit een mooi beeld geeft van de geschiedenis van Nav-Jeevan wil ik dit graag met u delen.
      </p>
      <br />

      <h3>
        Mijn ervaring met Nav-Jeevan,<i> door Annelies van de Ven</i>
      </h3>

      <p>
        Mijn naam is Annelies van de Ven. We hebben een zoon Paul (39) en twee geadopteerde dochters, Swatee (38) en
        Maya (37) uit Nagpur. In 1997 maakten Tom en ik, samen met de kinderen, onze eerste reis naar India.
      </p>
      <p>
        We reisden rond in het noorden van India en bezochten het weeshuis van onze dochters in Nagpur, Shishu Sangopan
        Griha, dat inmiddels geen weeshuis meer was maar een kinderdagverblijf. We ontmoetten ook Iris Wilkinson, de
        vroegere directeur, en haar dochter Aneeta Patel. Swatee en Maya waren ontroerd om weer terug in hun
        geboorteplaats te zijn.
      </p>
      <p>
        In 1998 reisden we opnieuw naar India. We bezocht Orissa, Kerala en het zuiden en natuurlijk reisden we op het
        eind weer naar Nagpur. Met de hulp van George Verghese, Nitin Totewar and Najib Khan van Siti Cable, slaagden we
        erin Maya&apos;s moeder en vijf halfbroertjes te vinden. Dit was een erg emotioneel moment. We hebben nog steeds
        een erg goed contact en bezoeken hen elk jaar als we in Nagpur zijn.
        <br />
        In 1999 gingen we opnieuw naar Nagpur in de hoop Swatees moeder te vinden, maar tot nu toe zonder succes.
      </p>
      <p>
        Tijdens onze reizen door India zag ik de armoede. Ik kon de beelden nier loslaten en voelde dat ik iets moest
        doen. Zo kwam her idee bij me op een project te starten voor de allerarmsten in Nagpur.
      </p>
      <p>
        In 2002 vertelde de eigenaar van ons bedrijf dat hij van plan was te participeren in een project. Hij wilde elke
        euro die zijn personeel doneerde verdubbelen. Ik dacht: “dit is de kans een project in Nagpur te starten”. Dus
        reisden we opnieuw naar Nagpur om met mensen te praten en te zien of er goede idee&euml;n waren. Iris Wilkinson,
        die een erg inspirerende vrouw is, was het meest enthousiast en kwam met het idee een project voor de
        straatkinderen uit de sloppenwijken van Nagpur te starten. n november 2002 werd de Nederlandse Stichting
        Nav-Jeevan opgericht en in januari 2003 volgde Nav Jeevan Sanstha in Nagpur.
        <br />
        Het idee was dat de Nederlandse stichting geld inzamelde en dat Nav Jeevan Sanstha zou zorgen voor de
        implementatie van het project. Dit is hoe we zijn begonnen en hoe het nog steeds werkt.
      </p>

      <Image src={Image13} alt="" />
      <br />

      <p>
        We startten met ongeveer 10 kinderen in een gehuurd appartement. Je kunt niet anders dan van deze kinderen te
        houden, soms ziek, vol luizen en vuile handen. Maar ze zijn als alle andere kinderen, met sympathie&euml;n,
        antipathie&euml;n, verwachtingen en ambities.
        <br />
        Zij willen dat er van ze gehouden wordt en dat ze gewaardeerd worden. Ze hebben een sterk gevoel van
        onafhankelijkheid en staan niemand toe, zelfs ons niet, inbreuk te maken op hun vrijheid. Grenzen van kaste,
        cultuur, religie of zelfs welvaart doen geen afbreuk aan hun voorkeuren.
        <br />
        Ze zijn echt kinderen van de natuur. Helaas is waar ze wonen geen spoor van de natuur, tenzij je rekening houdt
        met hun open hutten.
        <br />
        Je krijgt een heel vredig gevoel als je bij deze kinderen bent. De conflicten van het leven lijken onbelangrijk.
        Hun geluk, plezier en hoop op een beter leven raakt je. Zij hebben alles in hun leven tegen. Als iemand een kans
        in het leven verdient zijn zij het wel.
      </p>
      <p>
        Het aantal kinderen groeide snel dus kochten we een stuk land en begonnen met de bouw van een school en hostel.
        Helaas kwam het hostel te laat voor een aantal kinderen zoals Bebe, Hemant en Mangal. Zij waren te lang gewend
        aan tabak kauwen, stelen en bedelen. Ik was erg dol op deze kinderen. Met pijn in mijn hart moesten we ze laten
        gaan.
      </p>

      <LeftAlignedImage src={Image14} alt="">
        <p>
          Bebe was 6 jaar toen hij bij ons kwam, samen met zijn broer Bantu. altijd rondrennend, springend en
          salto&apos;s makend. Een van de maatschappelijk werksters ontdekte dat hij een klein propje tabak in zijn wang
          had verstopt. Zijn slechte en bevlekte tanden verraadden hem. Het lijkt een veel voorkomende gewoonte te zijn
          onder de moslimkinderen. Ze weten allemaal waarom tabak kauwen gevaarlijk is, maar doen het toch.
        </p>
      </LeftAlignedImage>

      <LeftAlignedImage src={Image15} alt="">
        <p>
          Mangal was 5 jaar toen hij bij ons kwam, samen met zijn broer Sunny. Zij hadden geen ouders. Mangals hoofd zat
          helemaal onder de luizen. Zijn haar moest geschoren worden maar niet te kort anders zou de huid er afgaan. Pas
          toen de huid genezen was konden we luizenshampoo gebruiken.
        </p>
      </LeftAlignedImage>

      <LeftAlignedImage src={Image16} alt="">
        <p>
          Na een echtelijke ruzie werd de moeder van Hemant (5), zijn zusje Renuka (8) en broer Rajkumar (11), overgoten
          met kerosine en levend verbrand. De vader kreeg een nieuwe vrouw met 3 zonen. De stiefmoeder en haar zonen
          sloegen Renuka. Maar Hemant stal iets dus werd hij eruit gegooid. Toen sliep hij in een oud schoolgebouw en
          zwierf samen met Mangal en Sunny rond en bedelde als hij honger had.
        </p>
      </LeftAlignedImage>

      <p>
        Op 13 november 2005 was de opening van de nieuwe school en het hostel voor straatkinderen uit de sloppen van
        Nagpur. De kinderen oefenden maanden hun liedjes, dansjes en toneelstukjes. Ouders, personeel, vrijwilligers,
        familie en vrienden waren aanwezig. Het was een dag om nooit te vergeten. We kochten ook een schoolbus.
      </p>

      <Image src={Image17} alt="" />
      <br />

      <p>Gedurende de jaren die volgden veranderde er veel en we moesten veel problemen het hoofd bieden.</p>
      <p>
        In oktober 2013 kreeg de school erkenning als High School ( tot en met klas10). Het was een proces van jaren om
        dit te bereiken. In 2015 werd de school erkend als Junior College (tot en met klas 12).
        <br />
        Ik kijk met groot plezier terug op de picknicks en schoolreisjes die we met de kinderen maakten. Ze hadden
        zoveel plezier en we vonden het geweldig om ze te vergezellen.
      </p>

      <Image src={Image18} alt="" />
      <Image src={Image20} alt="" />
      <div />
      <Image src={Image19} alt="" />
      <Image src={Image21} alt="" />
      <Image src={Image22} alt="" />
      <div />
      <Image src={Image23} alt="" />
      <Image src={Image25} alt="" />
      <div />
      <Image src={Image24} alt="" />
      <div />
      <Image src={Image26} alt="" />
      <Image src={Image27} alt="" />
      <br />

      <p>
        We zijn erg gehecht aan de kinderen die niemand hebben om naar toe te gaan tijdens de vakanties. We nemen ze mee
        uit als de anderen naar huis gaan. Deze zes kinderen zijn al zo lang bij ons. We houden van ze en hopen de
        plaats van hun ouders in te kunnen nemen in de korte tijd dat we elk jaar in Nagpur zijn.
      </p>

      <Image src={Image28} alt="" />
      <br />

      <p>In 2019 zijn we gegroeid naar een school met ruim 500 leerlingen, 220 van hen verblijven in het hostel.</p>

      <div>Ons project in een notendop:</div>
      <ul className="ulminus">
        <li>In januari 2003: gestart met 10 kinderen</li>
        <li>November 2005: 40 kinderen op school in het nieuwe gebouw</li>
        <li>Schooljaar 2008-2009 220 kinderen op school waarvan 60 in het hostel</li>
        <li>Schooljaar 2011-2012 243 kinderen op school waarvan 121 in het hostel</li>
        <li>Schooljaar 2015-2016 345 kinderen op school waarvan 250 in het hostel</li>
        <li>Schooljaar 2018-2019 420 kinderen op school waarvan 220 in het hostel</li>
        <li>Start schooljaar 2019 ruim 500 kinderen op school waarvan ruim 200 in het hostel</li>
      </ul>

      <p>
        Zoveel mondjes voeden was niet makkelijk. Het was een zware last die op mijn schouders rustte. Dus waren we erg
        blij met het tribal project dat in 2015 startte. En ook Tech Mahindra startte met sponseren. Dit betekende dat
        Nav Jeevan Sanstha niet langer alleen afhankelijk was van donaties uit Nederland.
      </p>

      <p>
        We waren erg blij dat zovelen in oktober 2018 naar de re&uuml;nie kwamen. Toen we in 2003 startten hadden we
        nooit kunnen bedenken dat we zo zouden groeien. We zijn trots te zien hoe de kinderen zijn uitgegroeid tot
        prachtige jong volwassenen. De meesten deden Junior College en een aantal zelfs College. Anderen deden een
        cursus en hebben leuke banen nu. Enkele meisjes zijn getrouwd en hebben kinderen.
        <br />
        En dat is waarom we dit project gestart zijn. Door opleiding nieuwe kansen cre&euml;ren. Kansen om lezen en
        schrijven te leren en te groeien tot de personen die ze nu zijn. Sommigen waren slecht korte tijd bij ons maar
        de meesten waren vele jaren bij ons.
      </p>

      <p>
        We vonden het geweldig de verandering te zien die zij doormaakten en hopen dat ze dezelfde goede herinneringen
        aan hun tijd bij Nav Jeevan hebben als wij.
      </p>

      <Image src={Image29} alt="" />
      <br />

      <p>
        Ik wiI Iris, Aneeta, Vicky, Dhun, Manju, Noel, Reshim, de docenten, de bibliothecaris, de opzichters, het
        keukenpersoneel, de helpsters, de schoonmaaksters, de administrateur, de chauffeurs en de bewakers bedanken voor
        hun toewijding bij het werk met de kinderen. Zij maken Nav Jeevan samen tot een veilige en plezierige plek om te
        leven.
      </p>

      <hr
        style={{
          height: "0px",
          border: "2px solid #16235A",
          borderRadius: "4px",
        }}
      />

      <p>
        Wij verwelkomen Miriam en Hans van der Sloot als nieuwe actieve leden voor Nav-Jeevan. Zij gaan zich onder
        andere bezighouden met de werving van scholen en bedrijven.
      </p>

      <p>
        Met de groei van het aantal kinderen groeiden de behoeften ook. Vorige maand realiseerden we het laatste project
        tot nu toe, de aanschaf van een nieuwe schoolbus. De oude bus, die inmiddels 14 jaar oud was en meerdere keren
        per dag groepen kinderen vervoerde, was helemaal op.
      </p>

      <Image src={Image30} alt="" width="502" heigth="335" />
      <Image src={Image31} alt="" width="274" heigth="412" />
      <br />

      <p>
        Inmiddels hebben we een tekort aan klaslokalen. Bovendien eist de onderwijsinspectie dat school en hostel
        gescheiden worden en er een apart jongens en -meisjeshostel komt. Wat er nu moet gebeuren is 2 stukken grond
        zoeken in de buurt van de school waarop we twee hostels kunnen bouwen. We hebben nog geen exacte begroting maar
        duidelijk is dat hier veel geld voor nodig zal zijn. Daarom vragen wij u het project onder de aandacht van uw
        familie, vrienden en kennissen te brengen en hen te vragen donateur te worden.
        <br />
        Verder kunt u wellicht de school van uw kind benaderen of een bedrijf dat u kent vragen een bijdrage te leveren.
      </p>

      <p>
        Mocht u iemand kennen die binnenkort een jubileum heeft vraagt u hem/haar dan eens om in plaats van cadeaus een
        donatie aan Nav Jeevan te vragen. Of wellicht bent u zelf binnenkort jarig en denkt u eraan hetzelfde te doen.
        Als u voor deze gelegenheid een leuke collectebus met foto&#39;s van Nav-Jeevan nodig hebben laat het me dan
        even weten dan zorg ik dat die uw kant opkomt.
      </p>

      <p>Mocht u een donatie doen die speciaal voor het hostel bedoeld is wilt u dit dan apart vermelden.</p>

      <p>
        En dan wil ik u er nog op wijzen hoe u op een eenvoudige wijze, zonder dat het u iets kost, kunt zorgen dat er
        extra geld binnenkomt voor Nav-Jeevan. Nav-Jeevan heeft zich namelijk aangesloten bij Sponsor kliks.
        <br />
        Koopt u wel eens online? Ga dan eerst naar onze website en klik rechtsboven in de hoek op het logo van
        Sponsorkliks. Klik vervolgens op de balk en je komt uit bij ruim 300 winkels waar je precies hetzelfde betaalt
        maar er gaat een commissie naar Nav-Jeevan.
        <br />
        Je sponsort ons dus gratis door eerst op de balk te klikken, dan je winkel te kiezen en je bestelling te
        plaatsen! Het gaat hier niet alleen om webwinkels als bol.com maar ook als u bijvoorbeeld uw reis boekt via
        booking.com of KLM ontvangt Stichting Nav-Jeevan een commissie.
        <br />
        Je kunt ook rechtstreeks naar de website van Sponsorkliks,{" "}
        <a href="https://www.sponsorkliks.com" target="_blank" rel="noreferrer">
          www.sponsorkliks.com
        </a>
        , gaan maar vergeet dan niet eerst in de bovenste balk Stichting Nav-Jeevan in te vullen.
        <br />
        Je ziet nadat je je bestelling geplaatst hebt niet dat er een commissie naar Stichting Nav-Jeevan gaat maar het
        gebeurt wel.
      </p>

      <p className="backgroundAccent">
        Vertel dit tegen uw vrienden, familie, kennissen en buren. Zo kunnen zij allemaal bijdragen aan een beter leven
        voor de straatkinderen van Nav-Jeevan, zonder dat het hen iets kost.
      </p>

      <p>
        Om kosten te besparen willen we de nieuwsbrief voortaan per mail versturen. Zou u zo vriendelijk willen zijn uw
        emailadres te mailen naar <a href="mailto:avandeven@home.nl">avandeven@home.nl</a> of{" "}
        <a href="mailto:nav-jeevan@home.nl">nav-jeevan@home.nl</a>. Voor het Calder personeel bij voorkeur uw
        priv&eacute; emailadres. En hebt u een partner of kinderen die ook graag op de hoogte worden gehouden geef dan
        ook hun emailadres door. Mocht u de nieuwsbrief in de toekomst liever op papier blijven ontvangen laat het me
        dan ook even weten.
      </p>

      <p>Namens de 500 kinderen en de medewerkers van Nav Jeevan danken wij u hartelijk voor uw steun.</p>

      <Ondertekening />

    </LayoutNieuwsbrief>
  </Layout>
)

export default Nieuwsbrief
